/**
 * Formats a user's display name from firstName and lastName.
 * Falls back to email if the name is empty or blank.
 */
export function formatUserName(user: {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}): string {
  const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim();
  return fullName || user.email || "";
}
